/* stylelint-disable a11y/media-prefers-reduced-motion */
/* stylelint-disable a11y/no-outline-none */
/* stylelint-disable no-descending-specificity */
import { css } from '@emotion/core';
/* eslint frontbucket-patterns/no-new-emotion-styled: "warn" */
import styled from '@emotion/styled';

import { token } from '@atlaskit/tokens';

import { DeploymentStatusIconType } from 'src/components/pipelines/models';

import StatusIcon from '../../status-icon';

// DeploymentModal styles
export const Loading = styled.div({
  textAlign: 'center',
  padding: '100px 0 100px',
});

export const DeploymentChangesWrapper = styled.div({
  paddingTop: '26px',
  'header h4': {
    fontWeight: token('font.weight.medium'),
  },
});

export const ChangesTabs = styled.div({
  margin: `0 ${token('space.negative.100')} 0`,
  padding: '10px 0',
});

export const Linked = styled.a({
  fontWeight: token('font.weight.semibold'),
  fontFamily: token('font.family.code'),
  minWidth: '64px',
});

export const Unlinked = styled.span({
  color: token('color.text'),
  fontWeight: token('font.weight.semibold'),
  fontFamily: token('font.family.code'),
  minWidth: '64px',
});

// DeploymentItemCard styles
export const Card = styled.div<{ isTopCard: boolean; isElevated: boolean }>(
  props => ({
    position: 'absolute',
    top: props.isTopCard ? `65px` : `139px`,
    left: '9px',
    width: '334px',
    padding: `${token('space.100')} 10px`,
    height: '50px',
    background: token('elevation.surface'),
    borderRadius: '3px',
    alignItems: 'center',
  }),
  props =>
    props.isElevated
      ? `box-shadow: ${token('elevation.shadow.overlay')}`
      : `box-shadow: ${token('elevation.shadow.raised')}`
);

export const DeploymentItemCardHeader = styled.header({
  display: 'flex',
  alignItems: 'center',
});

export const CommitMessage = styled.div`
  word-break: break-word !important;
  max-height: 20px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  margin-top: ${token('space.025')};
  max-width: 280px;
  span {
    display: inline-block;
  }
`;

export const DeploymentDateWrapper = styled.div({
  marginLeft: token('space.050'),
  marginTop: '3px',
});

export const DeploymentAvatar = styled.div({
  position: 'absolute',
  top: '19px',
  right: '13px',
});

export const StatusLink = styled.a({
  font: token('font.body.large'),
  display: 'flex',
  alignItems: 'center',
  svg: {
    margin: `0 ${token('space.050')} 0 0`,
    width: '18px',
    height: '18px',
  },
});

// DeploymentItem styles
export const DeploymentItemWrapper = styled.div<{
  hasEnvironment?: boolean;
  hasTwoCards?: boolean;
}>(
  props => ({
    width: '370px',
    height: props.hasTwoCards ? `214px` : `140px`,
    position: 'relative',
    borderRadius: '5px',
  }),
  props =>
    props.hasEnvironment && `background: ${token('color.background.neutral')}`
);

export const DeploymentItemHeader = styled.div<{
  iconType?: DeploymentStatusIconType;
}>(
  props => ({
    display: 'flex',
    position: 'relative',
    alignItems: 'center',
    height: '58px',
    background: token('color.background.neutral'),
    width: '100%',
    borderRadius: '3px 3px 0 0',
    boxSizing: 'border-box',
    padding: '15px 17px',
    transition: '0.3s',

    color: props.iconType
      ? token('color.icon.inverse')
      : token('color.icon.subtle'),
  }),
  ({ iconType }) =>
    iconType === 'success' && `background: ${token('color.icon.success')}`,
  ({ iconType }) =>
    iconType === 'redeploy' && `background: ${token('color.icon.success')}`,
  ({ iconType }) =>
    iconType === 'paused' && `background: ${token('color.icon.success')}`,
  ({ iconType }) =>
    iconType === 'building' && `background: ${token('color.icon.information')}`,
  ({ iconType }) =>
    iconType === 'stopped' && `background: ${token('color.icon.subtle')}`,
  ({ iconType }) =>
    iconType === 'failed' && `background: ${token('color.icon.danger')}`,
  ({ iconType }) =>
    iconType === 'failedRedeploy' &&
    `background: ${token('color.icon.danger')}`,
  ({ iconType }) =>
    iconType === 'rerun' &&
    `background: ${token('color.icon.success')};
    path {
      fill: ${token('color.icon.success')};
    }`,
  ({ iconType }) =>
    !iconType &&
    `
			padding-left: 49px;
			&:after {
				content: '';
				display: block;
				width: 18px;
				height: 18px;
				border: 3px solid ${token('color.border')};
				border-radius: 20px;
				position: absolute;
				left: 16px;
			}`
);

export const DeploymentItemStatus = styled(StatusIcon as any)`
  height: 24px;
  width: 24px;
  margin-right: ${token('space.100')};
  color: inherit !important;
  svg {
    width: 24px;
    height: 24px;
    margin: 0;
  }
  &[data-state='icon-pending'] span {
    width: 24px;
    height: 24px;
    color: ${token('color.icon.information')};
    background: ${token('color.icon.inverse')};
    border-radius: 12px;
    &::after {
      height: 96px;
      font: ${token('font.body.large')};
      top: ${token('space.050')};
      margin-left: 3px;
    }
  }
` as any;

export const Title = styled.h4({
  margin: 0,
  font: token('font.heading.medium'),
  textOverflow: 'ellipsis',
  overflow: 'hidden',
  whiteSpace: 'nowrap',
  color: 'inherit',
});

export const ArrowIcon = styled.div({
  position: 'absolute',
  top: '98px',
  zIndex: 1,
  backgroundImage: `linear-gradient( to right, ${token(
    'color.icon'
  )} 33%, transparent 0% )`,
  backgroundPosition: 'bottom',
  backgroundSize: '6px 2px',
  backgroundRepeat: 'repeat-x',
  width: '266px',
  height: '2px',
  '&::after': {
    content: "''",
    display: 'block',
    background: token('color.icon'),
    width: '8px',
    height: '8px',
    position: 'absolute',
    top: '-3px',
    left: '-1px',
    borderRadius: '5px',
  },
  '&::before': {
    content: "''",
    position: 'absolute',
    width: 0,
    height: 0,
    borderTop: '5px solid transparent',
    borderBottom: '5px solid transparent',
    borderLeft: `10px solid ${token('color.icon')}`,
    right: '-1px',
    top: token('space.negative.050'),
  },
});

export const DeploymentArrowFrom = styled(ArrowIcon)({
  left: '-80px',
  width: '273px',
  '&::after': {
    display: 'none',
  },
});

export const DeploymentArrowTo = styled(ArrowIcon)({
  left: '183px',
});

export const EmptyCard = styled.div({
  position: 'absolute',
  top: '65px',
  left: token('space.100'),
  width: '356px',
  height: '66px',
  borderRadius: '3px',
  boxSizing: 'border-box',
  background: token('color.background.neutral'),
  border: `3px ${token('color.border')} solid`,
});

// DeploymentOverview styles
export const DeploymentOverviewWrapper = styled.div({
  justifyContent: 'center',
});

export const Deployments = styled.div({
  display: 'flex',
  width: '812px',
  marginTop: token('space.200'),
  justifyContent: 'space-between',
  position: 'relative',
  margin: 'auto',
});

export const FileContent = styled.div({
  border: `solid ${token('color.border')}`,
  borderWidth: '0 1px 1px',
  // eslint-disable-next-line @atlaskit/design-system/no-unsafe-design-token-usage
  borderRadius: `0 0 ${token('border.radius.100', '3px')} ${token(
    'border.radius.100',
    // eslint-disable-next-line @atlaskit/design-system/no-unsafe-design-token-usage
    '3px'
  )}`,
  boxSizing: 'border-box',
});

export const FileHeader = styled.div({
  alignItems: 'center',
  justifyContent: 'space-between',
  background: token('elevation.surface.sunken'),
  border: `1px solid ${token('color.border')}`,
  // eslint-disable-next-line @atlaskit/design-system/no-unsafe-design-token-usage
  borderRadius: token('border.radius.100', '3px'),
  boxSizing: 'border-box',
  display: 'flex',
  minHeight: token('space.500'),
  padding: `${token('space.050')} ${token('space.100')}`,
  outline: 0,
  '&:focus': {
    border: `2px solid ${token('color.border.focused')}`,
  },
});

export const FilePath = styled.div({
  alignSelf: 'center',
  marginLeft: token('space.100'),
  wordBreak: 'break-word',
  cursor: 'auto',
  'span:last-child': {
    fontWeight: token('font.weight.semibold'),
  },
});

const chunkSplitFontColor = token('color.text.subtlest');
const chunkSplitBackgroundColor = token('color.background.input');
const chunkSplitBorderColor = token('color.border');
const chunkCodeBorderLeftColor = token('color.border');
const lineNumberColor = token('color.text.subtlest');
const chunkCodeBackgroundColor = token('elevation.surface');
const chunkRemovedCodeBackgroundColor = token('color.background.danger');
const chunkNormalCodeBackgroundColor = token('color.background.success');
const conflictContentColor = token('color.background.warning');
const conflictMarkerColor = token('color.background.warning');

// Executing these ahead to avoid function interpolation inside Emotion CSS
const GRID_SIZE = 8;
// Ak Page widths copied from @atlaskit/page because they can't be imported
const defaultGridColumnWidth = GRID_SIZE * 10; // 80
export const fixedGridPageWidth = `${defaultGridColumnWidth * 12}px`; // 960
// 53 degrees allows the repeating gradient to align correctly on each row
const emptyLineBackground = `repeating-linear-gradient(53deg, transparent, transparent 2px, ${chunkSplitBorderColor} 3px, ${chunkSplitBorderColor} 3px,transparent 4px)`;
export const codeLineHeight = GRID_SIZE * 2.5;

export const LINE_COLORS = {
  add: chunkNormalCodeBackgroundColor,
  del: chunkRemovedCodeBackgroundColor,
  normal: chunkCodeBackgroundColor,
  empty: emptyLineBackground,
  loaded: chunkSplitBackgroundColor,
};

export const CONFLICT_COLORS = {
  content: conflictContentColor,
  marker: conflictMarkerColor,
};

export const LINE_BEFORE_CONTENT = {
  add: '+',
  del: '-',
  normal: '',
  empty: '',
  loaded: '',
};

export const LineNumbers = styled.div<{ gutterWidth: number }>(props => ({
  height: `${codeLineHeight}px`,
  font: token('font.body.UNSAFE_small'),
  fontFamily: token('font.family.code'),
  paddingBlock: token('space.025'),
  position: 'absolute',
  left: 0,
  display: 'flex',
  justifyContent: 'space-between',
  alignItems: 'center',
  boxSizing: 'border-box',
  width: props.gutterWidth,
  borderRight: `1px solid ${chunkCodeBorderLeftColor}`,
  padding: `0 ${token('space.100')}`,
  backgroundColor: chunkSplitBackgroundColor,
  color: lineNumberColor,
}));

export const Code = styled.pre<{ type: keyof typeof LINE_BEFORE_CONTENT }>(
  props => ({
    height: `${codeLineHeight}px`,
    font: token('font.body.UNSAFE_small'),
    fontFamily: token('font.family.code'),
    margin: 0,
    width: '100%',
    boxSizing: 'border-box',

    padding: LINE_BEFORE_CONTENT[props.type]
      ? `${token('space.025')} ${GRID_SIZE}px`
      : `${token('space.025')} ${GRID_SIZE}px ${token('space.025')} ${
          GRID_SIZE * 2
        }px`,

    '&::before': {
      content: `'${LINE_BEFORE_CONTENT[props.type]}'`,
      paddingRight: token('space.100'),
    },

    /* Hack to stop post <pre> gap on empty code lines */
    '&::after': {
      content: "''",
      display: 'inline-block',
    },

    '> del, > ins': {
      textDecoration: 'none',
      display: 'inline-block',
      height: `${codeLineHeight}px`,
      /* Ensures any empty tags worddiff might leave don't misalign the code */
      verticalAlign: 'middle',
    },

    '> del': {
      backgroundColor: token('color.background.danger'),
    },

    '> ins': {
      backgroundColor: token('color.background.success'),
    },
  })
);

export const InlineContent = (
  gutterWidth: number,
  conflictType: keyof typeof CONFLICT_COLORS,
  type: keyof typeof LINE_COLORS
) => {
  return css({
    left: gutterWidth,
    display: 'flex',
    background: conflictType
      ? CONFLICT_COLORS[conflictType]
      : LINE_COLORS[type],
    boxSizing: 'border-box',
    maxWidth: fixedGridPageWidth,
    position: 'sticky',
    '&::before': {
      backgroundColor: chunkSplitBackgroundColor,
      borderRight: `1px solid ${chunkCodeBorderLeftColor}`,
      boxSizing: 'border-box',
      color: lineNumberColor,
      content: "' '",
      display: 'block',
      flex: `0 0 ${`${gutterWidth}px`}`,
      marginLeft: `-${gutterWidth}px`,
    },
  });
};

export const ChunkHeadingWrapper = styled.div<{ gutterWidth: number }>(
  props => ({
    paddingLeft: props.gutterWidth,
    boxSizing: 'border-box',
    '&:focus i, &:hover i': {
      opacity: 1,
    },
    maxHeight: `${codeLineHeight + 4}px`,
    '&:not(:last-child)': {
      borderBottom: `1px solid ${chunkSplitBorderColor}`,
    },
    '&:last-child': {
      borderTop: `1px solid ${chunkSplitBorderColor}`,
    },
  })
);

export const LineWrapper = styled.div<{
  gutterWidth: number;
  conflictType: keyof typeof CONFLICT_COLORS;
  type: keyof typeof LINE_COLORS;
}>(props => ({
  boxSizing: 'border-box',
  paddingLeft: props.gutterWidth,
  background: props.conflictType
    ? CONFLICT_COLORS[props.conflictType]
    : LINE_COLORS[props.type],

  '&:focus i, &:hover i': {
    opacity: 1,
  },
}));

export const DiffWrapper = styled.div({
  display: 'flex',
  overflowY: 'hidden',
  boxSizing: 'border-box',
  '&:not(:last-child)': {
    borderRight: `1px solid ${chunkCodeBorderLeftColor}`,
  },
  '& + &': {
    borderLeft: 'none',
  },
});

export const SingleDiff = styled.div({
  width: '100%',
  position: 'relative',
  display: 'flex',
  backgroundColor: chunkCodeBackgroundColor,
});

export const ChunkHeading = styled.div({
  height: `${codeLineHeight}px`,
  boxSizing: 'border-box',
  minHeight: `${codeLineHeight}px`,
  padding: `0 ${token('space.100')}`,
  backgroundColor: chunkSplitBackgroundColor,
  color: chunkSplitFontColor,
  font: token('font.body.UNSAFE_small'),
  fontFamily: token('font.family.code'),
  whiteSpace: 'nowrap',
});

export const LineNumber = styled.div({
  display: 'inline-block',
  zIndex: 1,
});

export const Chunk = styled.div({
  width: '100%',
  overflowX: 'auto',
  /* FF shows vertical scroll even if overflow-x is set. */
  overflowY: 'hidden',
  '&:not(:last-child)': {
    borderBottom: `1px solid ${chunkSplitBorderColor}`,
  },
});

export const CodeScrollContainer = styled.div({
  display: 'inline-block',
  minWidth: '100%',
});

export const ChunksWrapper = styled.div({
  flexGrow: 1,
  width: 0,
});

export const LoadedLinesWrapper = styled.div({
  '&:first-of-type': {
    borderBottom: `1px solid ${chunkCodeBorderLeftColor}`,
  },
  '&:last-child': {
    borderTop: `1px solid ${chunkCodeBorderLeftColor}`,
  },
});

export const FileDiffWrapper = styled.div({
  width: '100%',
  padding: `${token('space.200')} 0`,
});

export const SingleFileDiffWrapper = styled.div({
  margin: `0 0 ${token('space.200')}`,
});

export const FileDiffPlaceholder = styled.div({
  height: '150px',
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'center',
});

export const IssueFlexContainer = styled.div({
  display: 'flex',
  alignItems: 'center',
});

export const IssuePaddedFlexContainer = styled.div({
  display: 'flex',
  alignItems: 'center',
  paddingLeft: token('space.200'),
  '&:last-child': {
    height: '24px',
  },
});

export const IssueWrapper = styled.div({
  width: '100%',
  padding: `${token('space.100')} 0`,
});

export const IssueCard = styled.div({
  display: 'flex',
  alignItems: 'center',
  width: '100%',
  padding: `${token('space.100')} 0`,
});

export const IssueKey = styled.div({
  a: {
    outline: 'none',
    paddingLeft: token('space.100'),
    color: token('color.link'),
    font: token('font.body'),
    fontWeight: token('font.weight.medium'),
    minWidth: '50px',
    whiteSpace: 'nowrap',
    '&:focus, &:hover, &:active, &:visited, &:link': {
      outline: 'none',
      color: token('color.link'),
    },
  },
});

export const IssueSummary = styled.div({
  paddingLeft: token('space.200'),
  whiteSpace: 'nowrap',
  overflow: 'hidden',
  textOverflow: 'ellipsis',
  flex: 1,
});

export const IssuesEmptyWrapper = styled.div({
  width: '100%',
  padding: '50px 0 0 0',
  textAlign: 'center',
});

export const AsyncIconPlaceholder = styled.span<{
  height: string;
  width: string;
}>(({ height, width }) => ({
  height,
  width,
  backgroundColor: token('color.background.input'),
  borderRadius: '3px',
  display: 'flex',
}));

export const AsyncIconImage = styled.img({
  overflow: 'hidden',
});

export const CommitDiffWrapper = styled.table({
  width: '100%',
  '&:first-of-type': {
    marginTop: token('space.100'),
  },
  'tbody, tfoot': {
    borderBottomWidth: 0,
  },
  'tfoot td': {
    textAlign: 'center',
  },
});

export const CommitDiffRow = styled.tr({
  width: '100%',
  td: {
    padding: token('space.100'),
    '&:first-of-type': {
      paddingLeft: 0,
      paddingRight: 0,
      width: '28px',
    },
    '&:nth-child(2)': {
      width: '63px',
      paddingRight: 0,
    },
    '&:last-child': {
      paddingRight: 0,
    },
  },
});

export const CommitDiffAuthorCell = styled.div({
  display: 'flex',
  alignItems: 'center',
  whiteSpace: 'nowrap',
  textOverflow: 'ellipsis',
  width: '28px',
  height: '28px',
});

export const CommitDiffMessageCell = styled.div({
  whiteSpace: 'nowrap',
  overflow: 'hidden',
  textOverflow: 'ellipsis',
  maxWidth: '600px',
});

export const CommitDiffDateCell = styled.div({
  whiteSpace: 'nowrap',
});

export const PullRequestWrapper = styled.div({
  width: '100%',
  padding: `${token('space.100')} 0`,
});

export const PullRequestRow = styled.div({
  width: '100%',
  display: 'flex',
  alignItems: 'center',
  margin: `${token('space.100')} 0`,
});

export const PullRequestAuthor = styled.div({
  width: '36px',
  height: '36px',
  marginRight: token('space.100'),
});

export const PullRequestDescription = styled.div({
  flex: '1 0 auto',
  maxWidth: 'calc(100% - 160px)',
});

export const PullRequestTitle = styled.div({
  display: 'flex',
  a: {
    color: token('color.text'),
    display: 'block',
    maxWidth: '50%',
    textOverflow: 'ellipsis',
    overflow: 'hidden',
    whiteSpace: 'nowrap',
  },
  alignItems: 'baseline',
});

export const PullRequestTargets = styled.div({
  color: token('color.text.subtlest'),
  display: 'flex',
  alignItems: 'center',
  marginLeft: '5px',
});

export const PullRequestState = styled.div({
  marginLeft: token('space.100'),
  flex: '1 0 auto',
  textAlign: 'right',
});
